<template>
  <div>
    <KTCodePreview v-bind:title="'Duyệt phiếu yêu cầu nhập hàng'">
      <template v-slot:preview>
        <b-card no-body class="full-width">
          <div>
            <div
              class="wizard wizard-4"
              id="kt_wizard_v4"
              data-wizard-state="step-first"
              data-wizard-clickable="true"
            >
              <!--begin: Wizard Nav-->
              <div class="wizard-nav" style="background-color: #eef0f8">
                <div class="wizard-steps">
                  <div
                    class="wizard-step"
                    data-wizard-type="step"
                    data-wizard-state="current"
                  >
                    <div class="wizard-wrapper">
                      <div class="wizard-label">
                        <div class="wizard-title">Thông tin</div>
                      </div>
                    </div>
                  </div>
                  <div class="wizard-step ml-1" data-wizard-type="step">
                    <div class="wizard-wrapper">
                      <div class="wizard-label">
                        <div class="wizard-title">Tệp đính kèm</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card card-custom card-shadowless rounded-top-0">
                <div class="card-body p-0">
                  <div class="row">
                    <div class="col-xl-12">
                      <div
                        class="py-8 px-4 py-lg-15 px-lg-4 pb-5 full-width"
                        data-wizard-type="step-content"
                        data-wizard-state="current"
                      >
                        <b-row class="mb-5">
                          <!-- INFO INPUT CONTROLS -->
                          <b-col md="6">
                            <POCommonInfo
                              :mainModel="mainModel"
                              :parentPO="false"
                              v-if="renderComponent"
                            />
                          </b-col>
                          <!-- INFO VAT INPUT CONTROLS -->
                          <b-col md="3">
                            <b-form-group :disabled="!editable">
                              <label>Doanh nghiệp:</label>
                              <b-form-select
                                class="select-style"
                                v-model="mainModel.companyId"
                                :options="listCompany"
                                size="sm"
                                value-field="id"
                                text-field="name"
                              >
                              </b-form-select>
                            </b-form-group>
                            <b-form-group>
                              <label>Hình thức thanh toán:</label>
                              <b-form-select
                                class="select-style"
                                v-model="mainModel.importType"
                                :options="listImportType"
                                size="sm"
                                value-field="id"
                                text-field="name"
                                disabled
                              >
                              </b-form-select>
                            </b-form-group>
                            <b-form-group>
                              <label>Chiết khấu:</label>
                              <b-row>
                                <b-col class="pr-0" cols="5">
                                  <b-form-select
                                    class="select-style"
                                    v-model="mainModel.discountType"
                                    :options="listAmountType"
                                    size="sm"
                                    value-field="id"
                                    text-field="name"
                                    disabled
                                  >
                                  </b-form-select>
                                </b-col>
                                <b-col class="pl-0" cols="7">
                                  <b-form-input
                                    class="input-style text-right"
                                    size="sm"
                                    v-model="mainModel.discountAmount"
                                    placeholder="Chiết khấu"
                                    disabled
                                  ></b-form-input>
                                </b-col>
                              </b-row>
                            </b-form-group>

                            <POVat
                              :editable="false"
                              :mainModel="mainModel"
                              v-if="renderComponent"
                            />
                          </b-col>
                          <!-- PAYMENT INPUT CONTROLS -->
                          <b-col>
                            <POPayment
                              :editable="false"
                              :mainModel="mainModel"
                              v-if="renderComponent"
                            />
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="8">
                            <span class="font-weight-bolder lable-size"
                              >Danh sách sản phẩm:</span
                            >
                          </b-col>
                          <b-col md="4">
                            <b-checkbox
                              v-model="mainModel.isVAT"
                              class="d-flex justify-content-end lable-size"
                              :disabled="true"
                              >Đơn giá đã bao gồm VAT
                            </b-checkbox>
                          </b-col>
                        </b-row>
                        <b-table
                          :fields="fieldProduct"
                          :items="mainModel.details"
                          v-if="renderComponent"
                          hover
                          bordered
                          class="mt-4"
                        >
                          <template v-slot:cell(productName)="row">
                            <span
                              v-text="row.item.barCode"
                              style="font-size: 11px"
                              v-show="row.item.barCode"
                            ></span>
                            <br />
                            <span
                              v-text="row.item.productCode"
                              style="font-size: 12px"
                              v-show="row.item.productCode"
                            ></span>
                            <br />
                            <span
                              v-text="row.item.productName"
                              style="white-space: normal; color: #3699ff"
                            ></span>
                          </template>
                        </b-table>

                        <div class="col-md-12" style="padding-left: 0px">
                          <div class="mb-5 mt-5">
                            <b-button
                              v-bind:style="btnCreate"
                              size="sm"
                              variant="primary"
                              class="mr-4"
                              @click="onSubmit"
                            >
                              Duyệt
                            </b-button>
                            <b-button
                              v-bind:style="btnCancel"
                              size="sm"
                              variant="warning"
                              class="mr-4"
                              @click="showModalCancel"
                            >
                              Trả phiếu
                            </b-button>
                          </div>
                          <CancelPO
                            ref="po-cancel"
                            :purchaseOrderCode="mainModel.code"
                            :purchaseOrderId="mainModel.id"
                            :mode="
                              mainModel.status === PURCHASE_ORDER_STATUS.READY
                                ? PURCHASE_ORDER_APPROVE_MODE.PURCHASE
                                : PURCHASE_ORDER_APPROVE_MODE.ACCOUNTANT
                            "
                            v-on:onSuccess="onBack"
                          />
                        </div>
                      </div>

                      <div
                        class="py-4 mb-5 full-width"
                        data-wizard-type="step-content"
                      >
                        <div class="upload-file col-12">
                          <UploadFile
                            v-if="mainModel.id"
                            :id="mainModel.id"
                            :entity="'purchase-orders'"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end: Wizard Nav -->
        </b-card>
      </template>
    </KTCodePreview>
  </div>
</template>

<style>
.table th,
.table td {
  padding: 0.75rem;
  vertical-align: middle;
  border-top: 1px solid #ecf0f3;
}
.table.b-table.table-sm > thead > tr > [aria-sort]:not(.b-table-sort-icon-left),
.table.b-table.table-sm
  > tfoot
  > tr
  > [aria-sort]:not(.b-table-sort-icon-left) {
  background-position: right calc(1.5rem / 2) center;
  padding-right: calc(0.3rem + 0.65em);
}
</style>

<script>
import KTCodePreview from '@/view/content/CodePreview.vue';
import { SET_BREADCRUMB } from '@/core/services/store/modules/breadcrumbs.module';
import moment from 'moment';
import ApiService from '@/core/services/api.service';
import { validationMixin } from 'vuelidate';
import {
  unMaskPrice,
  convertPrice,
  makeToastSuccess,
  makeToastFaile,
} from './../../../utils/common';
import { TIME_TRIGGER } from './../../../utils/constants';
import {
  AMOUNT_TYPE,
  PURCHASE_ORDER_APPROVE_MODE,
  PURCHASE_ORDER_STATUS,
} from './../../../utils/enum';
import CancelPO from '../../components/stock-slips/CancelPO';
import KTWizard from '@/assets/js/components/wizard';
import KTUtil from '@/assets/js/components/util';
import UploadFile from '@/view/modules/upload/Upload';
import POPayment from '../../components/purchase-orders/POPayment';
import POVat from '../../components/purchase-orders/POVat';
import POCommonInfo from '../../components/purchase-orders/POCommonInfo';

export default {
  mixins: [validationMixin],
  data() {
    return {
      dpConfigs: {
        date: {
          format: 'DD/MM/YYYY',
          useCurrent: false,
          showClear: true,
          showClose: true,
          minDate: false,
          maxDate: false,
          locale: 'vi',
          sideBySide: true,
        },
      },
      btnCreate: {
        fontWeight: '600!important',
        'margin-right': '-10px',
        width: '70px',
      },
      btnCancel: {
        fontWeight: '600!important',
        'margin-right': '-10px',
        width: '100px',
      },
      isNew: true,
      isSearching: false,
      listAmountType: [
        {
          id: 1,
          name: 'Tiền mặt',
        },
        {
          id: 2,
          name: '%',
        },
      ],
      fieldProduct: [
        {
          key: 'productName',
          label: 'Sản phẩm',
          sortable: false,
          thStyle: {
            fontWeight: 600,
            color: '#181c32',
            width: '20%',
          },
          tdClass: 'text-left',
        },
        {
          key: 'inStockQuantity',
          label: 'Tồn',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '5%' },
          tdClass: 'text-right',
        },
        {
          key: 'prevUnitPrice',
          label: 'Giá thấp nhất',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-right',
          formatter: (value) => {
            return value ? convertPrice(value) : 0;
          },
        },
        {
          key: 'salePowerWeek',
          label: 'Sức bán tuần',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-right',
        },
        {
          key: 'salePowerMonth',
          label: 'Sức bán tháng',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '10%' },
          tdClass: 'text-right',
        },
        {
          key: 'quantity',
          label: 'SL',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '7%' },
          tdClass: 'text-right',
        },
        {
          key: 'unitPrice',
          label: 'Đơn giá(VAT)',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '12%' },
          tdClass: 'text-right',
          formatter: (value) => {
            return value ? convertPrice(value) : 0;
          },
        },
        {
          key: 'totalAmount',
          label: 'Thành tiền',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '11%' },
          tdClass: 'text-right',
          formatter: (value) => {
            return value ? convertPrice(value) : 0;
          },
        },
        {
          key: 'salePrice',
          label: 'Đơn giá bán',
          sortable: false,
          thStyle: { fontWeight: 600, color: '#181c32', width: '12%' },
          tdClass: 'text-right',
          formatter: (value) => {
            return value ? convertPrice(value) : 0;
          },
        },
      ],
      renderComponent: true,
      mainModel: {
        id: null,
        code: '',
        status: 1,
        providerId: null,
        providerName: '',
        description: '',
        storeId: null,
        storeName: '',
        discountAmount: 0,
        discountType: 1,
        vatAmount: 0,
        vatType: 2,
        cashAmount: 0,
        cashAccountCode: '',
        cashAccountName: '',
        transferAmount: 0,
        transferAccountCode: '',
        transferAccountName: '',
        payDate: null,
        vatCode: '',
        vatDate: '',
        createdAt: '',
        createdBy: '',
        importType: 1,
        importReason: '',
        inChargeEmployeeName: '',
        companyId: null,
        isVAT: true,
        totalAmount: 0,
        details: [],
      },
      PURCHASE_ORDER_STATUS: PURCHASE_ORDER_STATUS,
      PURCHASE_ORDER_APPROVE_MODE: PURCHASE_ORDER_APPROVE_MODE,
      listImportType: [
        {
          id: 1,
          name: 'Đặt cọc',
        },
        {
          id: 2,
          name: 'Thanh toán tiền ngay',
        },
        {
          id: 3,
          name: 'Bù trừ đơn hàng',
        },
        {
          id: 4,
          name: 'Công nợ',
        },
        {
          id: 5,
          name: 'Ký gửi',
        },
      ],
      hashName: null,
      listCompany: [],
    };
  },
  components: {
    KTCodePreview,
    CancelPO,
    UploadFile,
    POCommonInfo,
    POPayment,
    POVat,
  },
  created() {
    this.fetchCompany();
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: 'Phiếu yêu cầu nhập hàng', route: '/purchase-orders' },
      { title: 'Duyệt phiếu yêu cầu nhập hàng' },
    ]);
    if (this.$route.query.id) {
      this.mainModel.id = this.$route.query.id;
      this.getInfoById();
    }
    // Initialize form wizard
    const hashName = this.$route.hash ? this.$route.hash.split('#')[1] : '';

    this.hashName = hashName === 'attach' ? 'attach' : null;

    const wizard = new KTWizard('kt_wizard_v4', {
      startStep: hashName === 'attach' ? 3 : 1, // initial active step number
      clickableSteps: true, // allow step clicking
    });

    wizard.on('beforeNext', function (/*wizardObj*/) {});

    wizard.on('change', function (/*wizardObj*/) {
      setTimeout(() => {
        KTUtil.scrollTop();
      }, 500);
    });
  },
  computed: {
    totalPrice() {
      let total = 0;
      for (let index = 0; index < this.mainModel.details.length; index++) {
        const element = this.mainModel.details[index];
        total +=
          unMaskPrice(element.unitPrice) * unMaskPrice(element.quantity) -
          unMaskPrice(element.discountAmount);
      }

      const discountValue = this.mainModel.discountAmount
        ? unMaskPrice(this.mainModel.discountAmount)
        : 0;
      let discountAmount = discountValue;
      if (this.mainModel.discountType === AMOUNT_TYPE.PERCENT) {
        discountAmount = (discountValue * total) / 100;
      }

      total = total - discountAmount;
      const vatValue = this.mainModel.vatAmount
        ? unMaskPrice(this.mainModel.vatAmount)
        : 0;

      let vatAmount = vatValue;
      if (this.mainModel.vatType === AMOUNT_TYPE.PERCENT) {
        vatAmount = (vatValue * total) / 100;
      }

      total = parseInt(total) + parseInt(vatAmount);
      return total;
    },
    totalDiscount() {
      let total = 0;
      for (let index = 0; index < this.mainModel.details.length; index++) {
        const element = this.mainModel.details[index];
        total += unMaskPrice(element.discountAmount) * 1;
      }
      return total;
    },
    totalQuantity() {
      let total = 0;
      for (let index = 0; index < this.mainModel.details.length; index++) {
        const element = this.mainModel.details[index];
        total += element.quantity * 1;
      }
      return total;
    },
  },
  methods: {
    convertPrice,
    forceRerender() {
      this.renderComponent = false;

      this.$nextTick(() => {
        this.renderComponent = true;
      });
    },
    onSubmit: async function () {
      if (!this.mainModel.providerId) {
        makeToastFaile('Vui lòng chọn nhà cung cấp!');
        return;
      }

      const data = {
        id: this.mainModel.id,
        mode:
          this.mainModel.status === PURCHASE_ORDER_STATUS.READY
            ? PURCHASE_ORDER_APPROVE_MODE.PURCHASE
            : PURCHASE_ORDER_APPROVE_MODE.ACCOUNTANT,
      };
      if (this.isNew === true) {
        this.isNew = false;
        ApiService.post('purchase-order/approve', data)
          .then(({ data }) => {
            if (data.status === 1) {
              this.isNew = true;
              makeToastSuccess(data.message);
              setTimeout(() => {
                this.$router.push({
                  name: 'list-purchase-orders',
                });
              }, TIME_TRIGGER);
            } else {
              this.isNew = true;
              makeToastFaile(data.message);
            }
          })
          .catch(({ response }) => {
            this.isNew = true;
            makeToastFaile(response.data.message);
          });
      }
    },
    getInfoById() {
      ApiService.get(`purchase-order/${this.mainModel.id}`)
        .then(({ data }) => {
          this.mainModel.status = data.data.status
            ? parseInt(data.data.status)
            : 1;
          this.mainModel.code = data.data.code ? data.data.code : '';
          this.mainModel.description = data.data.description
            ? data.data.description
            : '';
          this.mainModel.importReason = data.data.importReason
            ? data.data.importReason
            : '';
          this.mainModel.storeName = data.data.storeName
            ? data.data.storeName
            : '';
          this.mainModel.storeId = data.data.storeId;
          this.mainModel.companyId = data.data.companyId;
          this.mainModel.providerName = data.data.providerName
            ? data.data.providerName
            : '';
          this.mainModel.providerId = data.data.providerId;
          this.mainModel.createdBy = data.data.createdByName
            ? data.data.createdByName
            : '';
          this.mainModel.inChargeEmployeeName = data.data.inChargeEmployeeName
            ? data.data.inChargeEmployeeName
            : '';
          this.mainModel.createdAt = data.data.createdAt
            ? moment(data.data.createdAt).format('HH:mm:ss DD/MM/YYYY')
            : '';
          this.mainModel.discountAmount = data.data.discountAmount
            ? data.data.discountAmount
            : 0;
          this.mainModel.vatAmount = data.data.vatAmount
            ? data.data.vatAmount
            : 0;
          this.mainModel.isVAT = data.data.isVAT;
          this.mainModel.discountType = data.data.discountType
            ? data.data.discountType
            : 1;
          this.mainModel.vatType = data.data.vatType ? data.data.vatType : 2;
          this.mainModel.cashAmount = data.data.cashAmount
            ? data.data.cashAmount
            : 0;
          this.mainModel.cashAccountCode = data.data.cashAccountCode
            ? data.data.cashAccountCode
            : '';
          this.mainModel.transferAmount = data.data.transferAmount
            ? data.data.transferAmount
            : 0;
          this.mainModel.transferAccountCode = data.data.transferAccountCode
            ? data.data.transferAccountCode
            : '';
          this.mainModel.payDate = data.data.payDate
            ? moment(data.data.payDate).format('DD-MM-YYYY')
            : '';
          this.mainModel.vatDate = data.data.vatDate
            ? moment(data.data.vatDate).format('DD-MM-YYYY')
            : '';
          this.mainModel.cashAccountName = data.data.cashAccountName
            ? data.data.cashAccountName
            : '';
          this.mainModel.transferAccountName = data.data.transferAccountName
            ? data.data.transferAccountName
            : '';
          this.mainModel.vatCode = data.data.vatCode ? data.data.vatCode : '';
          this.mainModel.importType = data.data.type ? data.data.type : 1;
          this.mainModel.details = data.data.details.map((item) => {
            const totalAmount =
              item.quantity * item.unitPrice - item.discountAmount;
            return {
              ...item,
              totalAmount: totalAmount,
            };
          });
          this.onChangeVat();
          this.mainModel.totalAmount = data.data.totalAmount;
        })
        .catch(({ response }) => {
          makeToastFaile(response.$error);
        });
    },
    onBack() {
      this.$router.push({
        name: 'list-purchase-orders',
      });
    },
    showModalCancel() {
      this.$refs['po-cancel'].showModal();
    },
    fetchCompany: async function () {
      ApiService.get('/company').then((response) => {
        this.listCompany = response.data.data;
        this.listCompany.unshift({
          id: null,
          name: 'Chọn doanh nghiệp',
        });
      });
    },
    onChangeVat() {
      const vatTableField = this.fieldProduct.find(
        (field) => field.key === 'unitPrice'
      );
      if (vatTableField) {
        vatTableField.label = this.mainModel.isVAT
          ? 'Đơn giá (VAT)'
          : 'Đơn giá';
      }
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/sass/pages/wizard/wizard-4.scss';
</style>
